import React from 'react';

import PageHeader from '../components/PageHeader';

const HistoryPage = () => {
    return (
        <>
            <PageHeader name="История запросов" isVisible={false} />
        </>
    );
};

export default HistoryPage;